import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function CreditCardIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 20 20">
      <path
        d="M3.333 16.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 1.666 15V5q0-.687.49-1.177t1.177-.49h13.334q.687 0 1.177.49T18.334 5v10q0 .687-.49 1.177t-1.177.49zm0-6.667h13.334V6.667H3.333z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
